import { CREATE_DRAW_LOADING, CREATE_DRAW_SUCCESS, CREATE_DRAW_ERROR } from "../../../constant/actionTypes";

const potyDrawsReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_DRAW_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_DRAW_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_DRAW_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default potyDrawsReducer;